import palette from 'config/theme/palette'

export const COLORS = {
  red: palette.error.main,
  yellow: '#E4CE06',
  green: '#1F8D44',
}
